module.exports = __webpack_public_path__ + "img/pr.8cbdb1f3.svg";